/*
 * NxtChair — cookietoestemming + taalkeuze (gecombineerde eerste-bezoek-modal).
 *
 * AVG-uitgangspunten die hier hard in zitten:
 *  - Toestemming loopt UITSLUITEND via window.Shopify.customerPrivacy. We lezen of
 *    schrijven zelf nooit Shopify-cookies (dat breekt bij Shopify-updates).
 *  - Taalkeuze en cookiekeuze zijn twee losse interacties. Een taalwissel roept
 *    nooit setTrackingConsent aan; een cookiekeuze verandert nooit de taal.
 *  - Sluiten/wegklikken zonder keuze = niets toegestaan (geen impliciete toestemming),
 *    en we leggen dan ook niets vast: de modal komt terug tot er echt gekozen is.
 *  - Niet-essentiële scripts laden pas na toestemming; zie loadConsentedScripts().
 */
(function () {
  'use strict';

  var modal, overlay, prefsOpen = false, langSubmitting = false;

  /*
   * Persistente vlag. Dit is een MULTI-PAGE storefront: elke navigatie is een volledige
   * herlaad, dus een JS-variabele overleeft niets. De Customer Privacy-API is zelf wel
   * persistent, maar shouldShowBanner() blijft true zolang de consent-regio's in de
   * Shopify-admin niet actief zijn — dan opent de modal op elke pagina opnieuw.
   * Daarom schrijven we de beslissing ook zelf weg, met een cookie als fallback voor
   * browsers die localStorage blokkeren (Safari private mode).
   */
  var FLAG = 'nxtchair_consent_v1';

  function storeGet(k) {
    try { var v = localStorage.getItem(k); if (v) return v; } catch (e) {}
    var m = document.cookie.match('(^|;)\\s*' + k + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : null;
  }

  function storeSet(k, v) {
    try { localStorage.setItem(k, v); } catch (e) {}
    try {
      var d = new Date(); d.setFullYear(d.getFullYear() + 1);
      document.cookie = k + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }

  function api() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  /* Wacht op de Customer Privacy API; Shopify laadt die asynchroon. */
  function withApi(cb) {
    if (api()) { cb(api()); return; }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(err ? null : api());
      });
      return;
    }
    var tries = 0;
    var iv = setInterval(function () {
      if (api() || ++tries > 40) { clearInterval(iv); cb(api()); }
    }, 100);
  }

  /* Heeft de bezoeker al een keuze gemaakt? Eigen vlag is leidend (overleeft
     paginanavigatie gegarandeerd); de API is de tweede bron. */
  function hasDecided(cp) {
    if (storeGet(FLAG)) return true;
    try {
      if (!cp) return false;
      if (typeof cp.shouldShowBanner === 'function') return !cp.shouldShowBanner();
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        return !!(c.analytics || c.marketing || c.preferences || c.sale_of_data);
      }
    } catch (e) {}
    return false;
  }

  function openModal() {
    if (!modal) return;
    modal.classList.add('open');
    overlay.classList.add('open');
    var f = modal.querySelector('button, [href], input');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    document.addEventListener('keydown', onKey);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('open');
    overlay.classList.remove('open');
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) { if (e.key === 'Escape') dismiss(); }

  /* Wegklikken = géén toestemming en géén vastlegging. Modal keert terug bij het
     volgende bezoek, precies zoals de AVG-default voorschrijft. */
  function dismiss() { closeModal(); }

  /* ---------- Deel 1: cookietoestemming ---------- */

  function setConsent(consent, cp) {
    // Eerst onze eigen vlag: een expliciete keuze mag nooit verloren gaan,
    // ook niet als de Customer Privacy-API niet beschikbaar is of faalt.
    storeSet(FLAG, JSON.stringify({ t: Date.now(), c: consent }));
    if (!cp || typeof cp.setTrackingConsent !== 'function') {
      loadConsentedScripts(consent);
      closeModal();
      return;
    }
    cp.setTrackingConsent(consent, function () {
      loadConsentedScripts(consent);
      closeModal();
    });
  }

  function readCategoryToggles() {
    var out = { analytics: false, marketing: false, preferences: false };
    (modal.querySelectorAll('[data-ncc-cat]') || []).forEach(function (sw) {
      out[sw.getAttribute('data-ncc-cat')] = sw.getAttribute('aria-checked') === 'true';
    });
    return out;
  }

  /*
   * Niet-essentiële scripts. Audit (aug 2026): er draaien op dit moment GEEN
   * analytics-, marketing- of trackingscripts in dit thema. Zet ze hier neer
   * zodra ze er wél komen — dan laden ze automatisch pas na toestemming.
   */
  function loadConsentedScripts(c) {
    if (c && c.analytics) {
      // Voorbeeld: injectScript('https://www.googletagmanager.com/gtag/js?id=G-XXXX');
    }
    if (c && c.marketing) {
      // Instantly / Leadsy visitor tracking (gedefinieerd in theme.liquid <head>).
      if (typeof window.nxtLoadLeadsy === 'function') window.nxtLoadLeadsy();
    }
    document.dispatchEvent(new CustomEvent('nxtchair:consent', { detail: c || {} }));
  }

  /* ---------- Deel 2: taalkeuze ---------- */

  function bindLanguage() {
    var form = document.getElementById('ncc-lang-form');
    var input = document.getElementById('ncc-locale-input');
    if (!form || !input) return;

    var SEL = '[data-ncc-lang],[data-ncc-langlink]';

    // Voorselectie op browsertaal, alleen als die duidelijk EN of IT is.
    try {
      var current = (input.value || 'nl').slice(0, 2).toLowerCase();
      var nav = (navigator.language || '').slice(0, 2).toLowerCase();
      if ((nav === 'en' || nav === 'it') && nav !== current) {
        var match = modal.querySelector('[data-ncc-lang^="' + nav + '"],[data-ncc-langlink^="' + nav + '"]');
        if (match) {
          modal.querySelectorAll(SEL).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          match.setAttribute('aria-pressed', 'true');
        }
      }
    } catch (e) {}

    modal.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ncc-lang]');
      if (!btn || langSubmitting) return;
      var code = btn.getAttribute('data-ncc-lang');

      modal.querySelectorAll(SEL).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');

      // Al de actieve taal? Dan alleen markeren, niet herladen.
      if (code === input.value) return;

      // Shopify's eigen localization-form regelt routing én onthouden.
      // Bewust GEEN consent-call hier: taal is geen toestemming.
      langSubmitting = true;
      input.value = code;
      form.submit();
    });
  }

  /* ---------- Init ---------- */

  function init() {
    modal = document.getElementById('ncc-modal');
    overlay = document.getElementById('ncc-ov');
    if (!modal) return;

    bindLanguage();

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ncc-dismiss]')) { dismiss(); return; }

      var sw = e.target.closest('[data-ncc-cat]');
      if (sw && !sw.disabled) {
        sw.setAttribute('aria-checked', sw.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
        return;
      }

      if (e.target.closest('[data-ncc-prefs]')) {
        prefsOpen = !prefsOpen;
        document.getElementById('ncc-cats').classList.toggle('open', prefsOpen);
        document.getElementById('ncc-save-prefs').style.display = prefsOpen ? 'block' : 'none';
        return;
      }

      var act = e.target.closest('[data-ncc-consent]');
      if (act) {
        var mode = act.getAttribute('data-ncc-consent');
        var consent;
        if (mode === 'accept') consent = { analytics: true, marketing: true, preferences: true, sale_of_data: false };
        else if (mode === 'deny') consent = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
        else { consent = readCategoryToggles(); consent.sale_of_data = false; }
        withApi(function (cp) { setConsent(consent, cp); });
      }
    });

    if (overlay) overlay.addEventListener('click', dismiss);

    // Blijvende toegang tot voorkeuren (footer-link e.d.).
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ncc-open]')) { e.preventDefault(); openModal(); }
    });

    withApi(function (cp) {
      if (!hasDecided(cp)) {
        openModal();
      } else if (cp && typeof cp.currentVisitorConsent === 'function') {
        loadConsentedScripts(cp.currentVisitorConsent());
      } else {
        var saved = storeGet(FLAG);
        if (saved) { try { loadConsentedScripts(JSON.parse(saved).c || {}); } catch (e) {} }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
